import { render, staticRenderFns } from "./CardDetailsModal.vue?vue&type=template&id=31cba808&scoped=true&"
import script from "./CardDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./CardDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cba808",
  null
  
)

export default component.exports